var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Inject } from '../../index';
import DOMHTML from './html';
import Animater from './animate';
var DOMClasslist = /** @class */ (function (_super) {
    __extends(DOMClasslist, _super);
    function DOMClasslist() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DOMClasslist.prototype.containsClasses = function (element) {
        var classes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classes[_i - 1] = arguments[_i];
        }
        for (var _a = 0, classes_1 = classes; _a < classes_1.length; _a++) {
            var item = classes_1[_a];
            if (element.classList.contains(item)) {
                return true;
            }
        }
        return false;
    };
    DOMClasslist.prototype.addClasses = function (elements) {
        var classes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classes[_i - 1] = arguments[_i];
        }
        var _loop_1 = function (item) {
            if (elements instanceof Array) {
                elements.forEach(function (element) {
                    element === null || element === void 0 ? void 0 : element.classList.add(item);
                });
            }
            else {
                elements === null || elements === void 0 ? void 0 : elements.classList.add(item);
            }
        };
        for (var _a = 0, classes_2 = classes; _a < classes_2.length; _a++) {
            var item = classes_2[_a];
            _loop_1(item);
        }
    };
    DOMClasslist.prototype.removeClasses = function (elements) {
        var classes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classes[_i - 1] = arguments[_i];
        }
        var _loop_2 = function (item) {
            if (elements instanceof Array) {
                elements.forEach(function (element) {
                    element === null || element === void 0 ? void 0 : element.classList.remove(item);
                });
            }
            else {
                elements === null || elements === void 0 ? void 0 : elements.classList.remove(item);
            }
        };
        for (var _a = 0, classes_3 = classes; _a < classes_3.length; _a++) {
            var item = classes_3[_a];
            _loop_2(item);
        }
    };
    DOMClasslist.prototype.toggleClasses = function (elements) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var classes = args.filter(function (item) { return typeof item === 'string'; });
        var force = args.find(function (item) { return typeof item === 'boolean'; });
        var _loop_3 = function (item) {
            if (elements instanceof Array) {
                elements.forEach(function (element) {
                    element === null || element === void 0 ? void 0 : element.classList.toggle(item, force);
                });
            }
            else {
                elements === null || elements === void 0 ? void 0 : elements.classList.toggle(item, force);
            }
        };
        for (var _a = 0, classes_4 = classes; _a < classes_4.length; _a++) {
            var item = classes_4[_a];
            _loop_3(item);
        }
    };
    // converts the HTMLElement to a selector string
    DOMClasslist.prototype.toSelector = function (element) {
        if (element.id) {
            return "#".concat(element.id);
        }
        if (element.classList.length > 0) {
            return element.classList.toString().split(' ').map(function (className) { return ".".concat(className.trim()); }).join('');
        }
        return element.tagName.toLowerCase();
    };
    DOMClasslist.prototype.animate = function (animation) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var animate = this._animate;
        if (typeof args[0] === 'string') {
            animate = this._animate.withDisplay(args[0]);
        }
        args.forEach(function (item) {
            if (item instanceof Element) {
                animate[animation].bind(animate)(item);
            }
        });
        this._animate.withDisplay('block');
    };
    DOMClasslist.prototype.isVisible = function (element) {
        var style = window.getComputedStyle(element);
        return (style.display !== 'none') || element.classList.contains('js--fade-in');
    };
    __decorate([
        Inject(),
        __metadata("design:type", Animater)
    ], DOMClasslist.prototype, "_animate", void 0);
    return DOMClasslist;
}(DOMHTML));
export default DOMClasslist;
//# sourceMappingURL=classlist.js.map